import CtaBoxWithDescription from './catBoxWithDescription';

export default CtaBoxWithDescription;
